// extracted by mini-css-extract-plugin
export default {"itemWrapper":"style_itemWrapper__2t7Cs","buttonsWrapper":"style_buttonsWrapper__Tdx5Z","contentWrapper":"style_contentWrapper__hg7w-","identityImage":"style_identityImage__u4TXw"};